import { createFileRoute } from '@tanstack/react-router'
import InspectionDetailPage from '@/spa/pages/projects/InspectionDetailPage'
import { routeErrorComponent } from '../../../_shared/RouteError'

export const Route = createFileRoute('/projects/$id/inspections/$inspectionId')({
  component: InspectionDetailPage,
  errorComponent: routeErrorComponent,
})
